import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d5ac8cec"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "checkContainer"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dot"
}, null, -1));
const _hoisted_3 = {
  class: "leftPadding8 lightBlack"
};
const _hoisted_4 = {
  key: 0,
  class: "info"
};
const _hoisted_5 = {
  key: 1,
  class: "danger"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "leftPadding8 lighterBlack"
};
const _hoisted_8 = {
  class: "leftPadding8 lighterBlack"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "warning"
}, "隐患", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_nut_row = _resolveComponent("nut-row");
  const _component_nut_col = _resolveComponent("nut-col");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.matters, (mat, mi) => {
    return _openBlock(), _createElementBlock(_Fragment, {
      key: mi
    }, [_createVNode(_component_nut_row, {
      class: "leftCenter"
    }, {
      default: _withCtx(() => [_hoisted_2, _createElementVNode("span", null, " " + _toDisplayString(mat.matterName), 1)]),
      _: 2
    }, 1024), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mat.detail, (item, itemIndex) => {
      return _openBlock(), _createElementBlock(_Fragment, {
        key: itemIndex
      }, [_createVNode(_component_nut_row, {
        class: "leftCenter"
      }, {
        default: _withCtx(() => [_createVNode(_component_nut_col, {
          span: 20,
          class: "leftCenter"
        }, {
          default: _withCtx(() => [_createElementVNode("span", _hoisted_3, _toDisplayString(item.itemName), 1)]),
          _: 2
        }, 1024), _createVNode(_component_nut_col, {
          span: 4,
          class: "tags"
        }, {
          default: _withCtx(() => [item.noProblem ? (_openBlock(), _createElementBlock("span", _hoisted_4, "无问题")) : (_openBlock(), _createElementBlock("span", _hoisted_5, "待整改"))]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1024), _createVNode(_component_nut_row, {
        class: "leftCenter"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.problemImages, (img, imgIndex) => {
          return _openBlock(), _createElementBlock("img", {
            class: "leftPadding8",
            key: imgIndex,
            style: {
              "width": "120px",
              "height": "80px",
              "object-fit": "cover"
            },
            src: img
          }, null, 8, _hoisted_6);
        }), 128))]),
        _: 2
      }, 1024), !item.noProblem && item.problemRemark ? (_openBlock(), _createBlock(_component_nut_row, {
        key: 0,
        class: "leftCenter"
      }, {
        default: _withCtx(() => [_createElementVNode("span", _hoisted_7, _toDisplayString(item.problemRemark), 1)]),
        _: 2
      }, 1024)) : _createCommentVNode("", true)], 64);
    }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mat.hiddenDangers, (hd, hdi) => {
      return _openBlock(), _createBlock(_component_nut_row, {
        class: "leftCenter",
        key: hdi
      }, {
        default: _withCtx(() => [_createVNode(_component_nut_col, {
          span: 20,
          class: "leftCenter"
        }, {
          default: _withCtx(() => [_createElementVNode("span", _hoisted_8, _toDisplayString(hd), 1)]),
          _: 2
        }, 1024), _createVNode(_component_nut_col, {
          span: 4,
          class: "tags"
        }, {
          default: _withCtx(() => [_hoisted_9]),
          _: 1
        })]),
        _: 2
      }, 1024);
    }), 128))], 64);
  }), 128))]);
}